export default "__VITE_ASSET__d5xRzCSw__"